import React, { ReactElement } from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';

import type { ReviewStatsPeriodicInterface } from 'interfaces/review-stats.interface';
import Icon from 'atomic/icon/icon';

import './rating-table.scss';

const CompanyViewCardRatingTable: React.FC = (): ReactElement => {
    const reviewStatsPeriodic = useSelector(
        (state: { reviewStatsPeriodic: ReviewStatsPeriodicInterface[]; }) => state.reviewStatsPeriodic
    );

    const lastMonthStats = reviewStatsPeriodic.find(item => item.period === 'thirtyDays');
    const lastYearStats = reviewStatsPeriodic.find(item => item.period === 'oneYear');
    const everStats = reviewStatsPeriodic.find(item => item.period === 'ever');

    return (
        <table className="company-view-card__rating-table">
            <thead>
                <tr>
                    <th className="company-view-card__rating-table-title">
                        &nbsp;
                    </th>
                    <th className="company-view-card__rating-table-title">
                        30 dni
                    </th>
                    <th className="company-view-card__rating-table-title">
                        12 miesięcy
                    </th>
                    <th className="company-view-card__rating-table-title">
                        Wszystkie
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th colSpan={4} className="company-view-card__rating-table-header">
                        Opinie
                    </th>
                </tr>
                <tr>
                    <td className="company-view-card__rating-table-cell company-view-card__rating-table-cell--first">
                        <Icon icon="thumb-up-circle" className="company-view-card__rating-table-icon"/>
                    </td>
                    <td className="company-view-card__rating-table-cell">
                        {lastMonthStats?.positiveCount || 0}
                    </td>
                    <td className="company-view-card__rating-table-cell">
                        {lastYearStats?.positiveCount || 0}
                    </td>
                    <td className="company-view-card__rating-table-cell">
                        {everStats?.positiveCount || 0}
                    </td>
                </tr>
                <tr>
                    <td className="company-view-card__rating-table-cell">
                        <Icon icon="thumb-right-circle" className="company-view-card__rating-table-icon"/>
                    </td>
                    <td className="company-view-card__rating-table-cell">
                        {lastMonthStats?.neutralCount || 0}
                    </td>
                    <td className="company-view-card__rating-table-cell">
                        {lastYearStats?.neutralCount || 0}
                    </td>
                    <td className="company-view-card__rating-table-cell">
                        {everStats?.neutralCount || 0}
                    </td>
                </tr>
                <tr>
                    <td className="company-view-card__rating-table-cell">
                        <Icon icon="thumb-down-circle" className="company-view-card__rating-table-icon"/>
                    </td>
                    <td className="company-view-card__rating-table-cell">
                        {lastMonthStats?.negativeCount || 0}
                    </td>
                    <td className="company-view-card__rating-table-cell">
                        {lastYearStats?.negativeCount || 0}
                    </td>
                    <td className="company-view-card__rating-table-cell">
                        {everStats?.negativeCount || 0}
                    </td>
                </tr>
                <tr>
                    <th colSpan={4} className="company-view-card__rating-table-header">
                        Opinie wycofane/usunięte
                    </th>
                </tr>
                <tr>
                    <td className="company-view-card__rating-table-cell company-view-card__rating-table-cell--first">
                        <Icon icon="opiconnect-withdrawn" className="company-view-card__rating-table-icon"/>
                    </td>
                    <td className="company-view-card__rating-table-cell">
                        {lastMonthStats?.withdrawnByOpiconnectUserCount || 0}
                    </td>
                    <td className="company-view-card__rating-table-cell">
                        {lastYearStats?.withdrawnByOpiconnectUserCount || 0}
                    </td>
                    <td className="company-view-card__rating-table-cell">
                        {everStats?.withdrawnByOpiconnectUserCount || 0}
                    </td>
                </tr>
                <tr>
                    <td className="company-view-card__rating-table-cell">
                        <Icon icon="opiconnect-illegal" className="company-view-card__rating-table-icon"/>
                    </td>
                    <td className="company-view-card__rating-table-cell">
                        {lastMonthStats?.withdrawnByCustomerServiceCount || 0}
                    </td>
                    <td className="company-view-card__rating-table-cell">
                        {lastYearStats?.withdrawnByCustomerServiceCount || 0}
                    </td>
                    <td className="company-view-card__rating-table-cell">
                        {everStats?.withdrawnByCustomerServiceCount || 0}
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default CompanyViewCardRatingTable;
